/* eslint-disable react/sort-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */

import React, { Component, useState } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useMutation } from "@apollo/client";
import { v4 as uuidv4 } from "uuid";
import {
  LOCATIONS_VIA_ADDRESS_QUERY,
  STORES_QUERY
} from "../../graphql/location";
import { UPDATE_ORDER_LOCATION } from "../../graphql/order";
import * as storeRepo from "../../shared/repos/graphql/store";
// REDUX
import * as addressActions from "../../redux/actions/address";
import * as elementsActions from "../../redux/actions/elements";
import * as userActions from "../../redux/actions/user";
import * as countryActions from "../../redux/actions/country";
import * as loyaltyAction from '../../redux/actions/loyalty';

// COMPONENTS
import MapComponent from "../../components/MapComponent/MapComponent";
import DeliveryLocationListItem from "../../components/DeliveryLocationsListItem/DeliveryLocationsListItem";
import Loader from "../../components/Loader/Loader";
// HELPERS
import {
  getCurrentPosition,
  getGeolocationPermissionState,
} from "../../shared/utilities/geolocation";
import { BRAND_REFRESH_DEFAULT_CENTER } from "../../shared/utilities/brandRefreshMapStyles";
import { client, setSessionToken } from "../../shared/utilities/config";

// SUB UI RENDERINGS
import {
  handlePickupSubmit,
  renderChosenLocation,
  renderExitIcon,
  renderListItems
} from './renderings';
import
  DeliveryPickUpWidget
 from "../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import styles from './Locations.module.css';
import './LocationsBrandRefresh.module.css';
import {
  getLocationsInputWrapperClass,
  getLocationsListTitleClass,
  getLocationsMobilePanelClass,
  getLocationsNoStoresHeadingClass,
  getLocationsPageWrapperClass,
  getLocationsPageShellClass,
  getLocationsSearchInputClass,
  getLocationsSearchInputContainerClass,
  LOCATIONS_SEARCH_CLEAR_BTN_BR,
  LOCATIONS_SEARCH_CLEAR_ICON_BR,
  LOCATIONS_SEARCH_FIELD_GROUP_BR,
  LOCATIONS_SEARCH_ICON_BR,
  LOCATIONS_SEARCH_LOCATION_BTN_BR,
} from './locationsBrandRefreshClasses';
import {orderMethods, orderTypeIds} from "../../shared/constants/order";
import {shippingMethods} from "../../shared/constants/store";
import * as orderRepo from "../../shared/repos/graphql/order";
import * as reduxStore from "../../redux/store";
import { routeCountryPath } from "../../shared/utilities/common";
import { METADATA_INFO } from "../../shared/constants/common";
import endpoints from "../../shared/constants/endpoints";
import {setCaptchaToken} from "../../shared/utilities/captcha";
import captchaAction from "../../shared/constants/captchaAction";
import httpStatusConstant from "../../shared/constants/httpStatus";
import ReCAPTCHAForm from "../../components/ReCaptcha/ReCaptcha";
import elementConstants from "../../shared/constants/element";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";

const searchIcon = require("./imgs/search-icon.svg");
const searchIconBrandRefresh = require("./imgs/search-icon-brand-refresh.svg");
const searchArrow = require("./imgs/current-location-icon.svg");
const navigationArrowBrandRefresh = require("./imgs/navigation-arrow-brand-refresh.svg");
const locationIcon = require("./imgs/location-icon.svg");
const locationPinBrandRefresh = require("./imgs/location-pin-brand-refresh.svg");
const clearIcon = require("./imgs/close-icon.svg");
const clearIconBrandRefresh = require("./imgs/close-icon-brand-refresh.svg");
const lightExitIcon = require("./imgs/light-exit-icon.svg");
const mobileBackIcon = require("./imgs/mobile-back.svg");
const listBulletsBrandRefresh = require("./imgs/list-bullets-brand-refresh.svg");
const mapTrifoldBrandRefresh = require("./imgs/map-trifold-brand-refresh.svg");

class Locations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locationsList: props.location?.state?.stores || [],
      showLocation: false,
      selectedAddress: "",
      mobileSearchHeight: "calc(40vh)",
      searchValue: props.widgetValue,
      searchLocation: { lat: null, lng: null, externalId: null },
      chosenLocationIndex: undefined,
      locationLoading: false,
      storesLoading: false,
      showDefaultMap: false,
      selectedStoreIdFromTheSearchList: null,
      showModal: false,
      addressType: "pickup",
      selectedStore: {},
      showLocationSearchResults: false,
      hasCaptchaError: false,
      showCaptchaChallenge: false,
      skipGenerateNewToken: false,
      locationSearchError: null,
      locationAccessDenied: false,
      mobileViewMode: 'map',
    };
    this.searchInput = React.createRef();
    this.stores = React.createRef();
    this.recaptchaComponentRef = React.createRef();
    this.isLocationsMounted = false;
    this.brandRefreshGeoGeneration = 0;
    this.brandRefreshGeoTimeoutId = null;

    this.setSearchPosition = this.setSearchPosition.bind(this);
  }

  componentDidMount() {
    this.isLocationsMounted = true;
    setSessionToken(uuidv4());
    const { match, useRecaptcha, setVerificationToken, setVerificationAction } = this.props;
    const storeId = match.params.store_id;

    if (storeId) {
      if (!Number.isNaN(storeId) && !Number.isNaN(parseFloat(storeId))) {
        this.getStore(storeId);
      } else {
        this.getStoreByLocationName(storeId);
      }
    } else {
      this.initState();
    }

    if (useRecaptcha === 1) {
      const { skipGenerateNewToken } = this.state;
      setCaptchaToken(setVerificationToken, setVerificationAction, captchaAction.addressSearching, skipGenerateNewToken);
    }
  }

  async componentDidUpdate(prevProps) {
    const { location, selectedMapStore } = this.props;
    if (location !== prevProps.location) {
      this.initState();
    }

    if (prevProps.selectedMapStore !== selectedMapStore) {
      await this.handleSelectedMapStore();
    }
  }

  componentWillUnmount() {
    this.isLocationsMounted = false;
    this.brandRefreshGeoGeneration += 1;
    this.clearBrandRefreshGeoTimeout();
    const { setRedeemableItem } = this.props;
    if (typeof setRedeemableItem === 'function') {
      setRedeemableItem({
        redeemableType: null,
        redeemableId: null
      });
    }
  }

  async handleSelectedMapStore() {
    const { showLocation } = this.state;
    const { setSelectedMapStore, selectedMapStore } = this.props;

    if (isBrandRefreshEnabled()) {
      this.setState({
        selectedStoreIdFromTheSearchList: selectedMapStore?.id || null,
      });
      return;
    }

    if (showLocation) {
      await this.closeShownLocation();

      setTimeout(() => {
        setSelectedMapStore({ ...selectedMapStore });
      });
    }
  }

  async closeShownLocation() {
    await this.setState({ showLocation: false });
  }

  initState() {
    const { location } = this.props;
    const { showLocation } = this.state;
    let shouldRequestGeolocation = true;

    if (location?.state?.showLocationSearchResults) {
      this.setState({
        showLocationSearchResults: location.state.showLocationSearchResults,
        searchValue: location.state.selectedAddress
      });
    }

    if (
      location.state &&
      location.state.myLocation &&
      location.state.searchLocation &&
      location.state.selectedAddress &&
      location.state.stores
    ) {
      const locationsList = location.state.stores ? location.state.stores : [];
      const isShowLocation = locationsList.length === 0 ? false : showLocation;

      this.setState({
        searchLocation: location.state.searchLocation,
        myLocation: { lat: "", lng: "" },
        locationsList,
        selectedAddress: location.state.selectedAddress,
        searchValue: location.state.selectedAddress,
        showLocation: isShowLocation
      });

      // Restored navigation state can include an address with an empty store list.
      // Refetch that location and skip competing page-load geo (#19081).
      if (
        !locationsList.length &&
        location.state.searchLocation &&
        (location.state.searchLocation.lat || location.state.searchLocation.externalId)
      ) {
        this.brandRefreshGeoGeneration += 1;
        this.clearBrandRefreshGeoTimeout();
        this.setState({ locationLoading: false });
        this.getStores(location.state.searchLocation);
        shouldRequestGeolocation = false;
      }
    }

    if (shouldRequestGeolocation) {
      this.getCurrentPosition();
    }
  }

  /**
   * Brand-refresh: apply a successful geocode response the same way as the
   * location-arrow click path (lat/lng + externalId → getStores).
   * Avoids the legacy setSearchPosition early-return / externalId-only bugs (#19081).
   */
  applyBrandRefreshGeolocationResult = response => {
    if (
      !response ||
      !response.results ||
      !response.results[0] ||
      !response.results[0].geometry ||
      !response.results[0].geometry.location
    ) {
      // Not a permission denial — keep the location arrow available to retry.
      this.useDefaultLocationFallback({ accessDenied: false });
      return;
    }

    const place = response.results[0];
    const { lat, lng } = place.geometry.location;
    const address = place.formatted_address;
    const searchLocation = {
      externalId: place.place_id,
      lat,
      lng,
    };

    this.setState({
      locationLoading: false,
      locationAccessDenied: false,
      searchValue: address,
      selectedAddress: address,
      searchLocation,
      myLocation: searchLocation,
      myAddress: address,
    });
    this.getStores(searchLocation);
  };

  clearBrandRefreshGeoTimeout = () => {
    if (this.brandRefreshGeoTimeoutId) {
      clearTimeout(this.brandRefreshGeoTimeoutId);
      this.brandRefreshGeoTimeoutId = null;
    }
  };

  /**
   * Shared brand-refresh geolocation request: hang timeout + mount/generation
   * settle so late callbacks cannot overwrite a newer search (#19081).
   */
  requestBrandRefreshGeolocation = () => {
    this.setState({ locationLoading: true, locationAccessDenied: false });

    this.clearBrandRefreshGeoTimeout();
    const generation = (this.brandRefreshGeoGeneration || 0) + 1;
    this.brandRefreshGeoGeneration = generation;
    let settled = false;
    const settle = handler => {
      if (
        settled ||
        !this.isLocationsMounted ||
        generation !== this.brandRefreshGeoGeneration
      ) {
        return;
      }
      settled = true;
      this.clearBrandRefreshGeoTimeout();
      handler();
    };

    this.brandRefreshGeoTimeoutId = setTimeout(() => {
      // Hang ≠ permission denied — keep arrow so user can retry.
      settle(() => this.useDefaultLocationFallback({ accessDenied: false }));
    }, 4000);

    getCurrentPosition(response => {
      settle(() => this.applyBrandRefreshGeolocationResult(response));
    }, null);
  };

  async getCurrentPosition() {
    const { location } = this.props;
    const locationDefined = !!(location.lat && location.lng);

    if (locationDefined) return;

    if (isBrandRefreshEnabled()) {
      if (!window.navigator?.geolocation) {
        this.useDefaultLocationFallback({ accessDenied: true });
        return;
      }

      const permissionState = await getGeolocationPermissionState();
      if (!this.isLocationsMounted) {
        return;
      }
      if (permissionState === 'denied') {
        this.useDefaultLocationFallback({ accessDenied: true });
        return;
      }

      // Page-load geolocation can hang without a user gesture. Seed Philly
      // results if the browser never answers (#19081).
      this.requestBrandRefreshGeolocation();
      return;
    }

    this.setState({ locationLoading: true });
    getCurrentPosition(this.setSearchPosition, this);
  }

  useDefaultLocationFallback = ({ accessDenied = true } = {}) => {
    this.clearBrandRefreshGeoTimeout();
    this.setState({
      locationLoading: false,
      locationAccessDenied: accessDenied,
      searchValue: "",
      selectedAddress: "",
      searchLocation: { ...BRAND_REFRESH_DEFAULT_CENTER },
    });
    this.getStores({ ...BRAND_REFRESH_DEFAULT_CENTER });
  };

  setSearchPosition(response) {
    const { searchValue, selectedAddress } = this.state;
    const { location } = this.props;
    const hasSelectedAddress = !!(
      location.state && location.state.selectedAddress
    );
    let address = "";

    if (
      (selectedAddress === "" || selectedAddress === undefined) &&
      response &&
      response.results &&
      response.results[0] &&
      response.results[0].place_id &&
      response.results[0].geometry &&
      response.results[0].geometry.location &&
      response.results[0].geometry.location.lat &&
      response.results[0].geometry.location.lng
    ) {
      this.setState({
        searchLocation: {
          externalId: response.results[0].place_id,
          lat: response.results[0].geometry.location.lat,
          lng: response.results[0].geometry.location.lng
        }
      });
    }

    if (searchValue !== "" && searchValue !== undefined) {
      this.setState({
        locationLoading: false
      });
      return null;
    }

    if (!response) {
      const data = {
        searchValue: address,
        locationLoading: false,
        selectedAddress: address
      };

      if (location.state) {
        address = location.state.selectedAddress;

        data.selectedAddress = address;
        data.searchValue = address;

        this.getStores(location.state.searchLocation);
      }

      this.setState({
        locationLoading: false,
        searchValue: address,
        selectedAddress: address
      });
      return null;
    }

    address = hasSelectedAddress
      ? location.state.selectedAddress
      : response.results[0].formatted_address;

    const myAddress = response.results[0].formatted_address;
    const externalId = response.results[0].place_id;

    const positionLocation = {
      externalId
    };

    const stateSearchLocation = hasSelectedAddress
      ? location.state.searchLocation
      : positionLocation;

    this.setState({
      locationLoading: false,
      searchValue: address,
      selectedAddress: address,
      searchLocation: stateSearchLocation,
      myLocation: positionLocation,
      myAddress
    });

    if (!location?.state?.stores?.length) {
      return this.getStores(stateSearchLocation);
    }
    return null;
  }

  async getStores(variables) {
    const { storesLoading } = this.state;

    if (storesLoading) {
      return;
    }

    this.setStoreLoading(true);

    try {
      const response = await client.query({
        query: STORES_QUERY,
        fetchPolicy: "network-only",
        variables
      });

      this.getStoresCallback(response.data.storeSearch);
    } catch (e) {
      this.setStoreLoading(false);
    }
  }

  getStore(id) {
    this.setStoreLoading(true);

    const { setAutocompleteSessionToken } = this.props;
    try {
      storeRepo.getStore(id).then(response => {
        if (response.data.store) {
          setAutocompleteSessionToken(null);
          const locationsList = response.data.store
            ? [response.data.store]
            : [];
          this.setState({
            showDefaultMap: false,
            selectedAddress: " ",
            locationsList,
            chosenLocationIndex: 0,
            showLocation: locationsList.length > 0
          });
        } else {
          this.setState({
            showLocation: false,
            searchValue: " ",
            selectedAddress: " ",
            locationsList: []
          });
        }
        this.setStoreLoading(false);
      });
    } catch (err) {
      this.setState({
        showLocation: false,
        searchValue: " ",
        selectedAddress: " ",
        locationsList: []
      });
      this.setStoreLoading(false);
    }
  }

  getStoreByLocationName(locationName) {
    this.setStoreLoading(true);
    const { setAutocompleteSessionToken } = this.props;
    try {
      storeRepo.getStoreByLocationName(locationName).then(response => {
        if (response.data.storesByLocation) {
          setAutocompleteSessionToken(null);
          const locationsList = response.data.storesByLocation
            ? [response.data.storesByLocation]
            : [];
          this.setState({
            showDefaultMap: false,
            selectedAddress: " ",
            locationsList,
            chosenLocationIndex: 0,
            showLocation: locationsList.length > 0
          });
        } else {
          this.setState({
            showLocation: false,
            searchValue: " ",
            selectedAddress: " ",
            locationsList: []
          });
        }
        this.setStoreLoading(false);
      });
    } catch (err) {
      this.setState({
        showLocation: false,
        searchValue: " ",
        selectedAddress: " ",
        locationsList: []
      });
      this.setStoreLoading(false);
    }
  }

  storeSelect = async (e, updateOrderLocation) => {
    const { orderProducts, userOrderMethod } = this.props;
    const { selectedStore } = this.state;
    const currentOrderNotPickup = userOrderMethod
      ? userOrderMethod !== orderMethods.pickup
      : false;
    const isItemInCart =
      Array.isArray(orderProducts) && orderProducts.length > 0;
    const changeStock = currentOrderNotPickup || isItemInCart;
    await handlePickupSubmit(
      e,
      changeStock,
      this,
      selectedStore,
      updateOrderLocation
    );
  };

  onCloseWidget = (setShowDeliveryWidget) => {
    this.setState({
      showModal: false,
    })
    setShowDeliveryWidget(false);
  };

  getStoresCallback(storeSearch) {
    const {
      addressUpdated,
      setAutocompleteSessionToken,
      setSelectedMapStore,
    } = this.props;
    const { selectedAddress, searchLocation, showLocation } = this.state;

    addressUpdated(storeSearch.address);

    const storeSearchCoords = {
      lat: storeSearch.lat,
      lng: storeSearch.lng
    };
    const locationsList = storeSearch.stores ? storeSearch.stores : [];
    if (locationsList.length > 0) {
      setAutocompleteSessionToken(null);
      setSessionToken(uuidv4());
    }
    const isShowLocation = locationsList.length === 0 ? false : showLocation;

    if (typeof setSelectedMapStore === 'function') {
      setSelectedMapStore(null);
    }
    this.setState({
      showDefaultMap: false,
      locationsList,
      searchLocation: selectedAddress
        ? {
            ...searchLocation,
            ...storeSearchCoords
          }
        : storeSearchCoords,
      showLocation: isShowLocation,
      showLocationSearchResults: locationsList.length > 0,
      selectedStoreIdFromTheSearchList: null,
    });
    this.setStoreLoading(false);
  }

  myLocationSearch() {
    const { myAddress, myLocation } = this.state;

    this.setState({
      searchValue: myAddress
    });

    this.getStores(myLocation);
  }

  handleMapGeolocate = async () => {
    if (!window.navigator?.geolocation) {
      this.useDefaultLocationFallback({ accessDenied: true });
      return;
    }

    const permissionState = await getGeolocationPermissionState();
    if (!this.isLocationsMounted) {
      return;
    }
    if (permissionState === 'denied') {
      this.useDefaultLocationFallback({ accessDenied: true });
      return;
    }

    this.requestBrandRefreshGeolocation();
  };

  redirectToPdp = location => {
    const { redeemables, setRedeemableItem } = this.props;

    if (redeemables?.redeemableType) {
      setRedeemableItem({
        redeemableType: null,
        redeemableId: null
      })
      return routeCountryPath(endpoints.loyalty);
    }

    return location;
  };

  /**
   * Clears search value state
   */
  clearSearch = () => {
    const { setWidgetValue, setSelectedMapStore } = this.props;
    this.setState({
      searchValue: "",
      showLocationSearchResults: true,
    });
    setWidgetValue("");
    this.searchInput.current.focus();
    setSelectedMapStore(null);
  };

  /**
   * Handles location filtering based on input component value
   * @param value
   * @param variables
   */

  handleLocationFilter(value, variables) {
    const { setWidgetValue } = this.props;
    const { locationsList, selectedAddress } = this.state;
    const minLengthMet = value.length > 2;
    
    setWidgetValue("");
  
    this.setState({
      searchValue: value,
      selectedAddress: "",
      showLocationSearchResults: !(locationsList.length > 0),
    });
    
    if (!minLengthMet && locationsList.length === 0)
      return this.setState({ mobileSearchHeight: 90 });
    
    this.setState({ mobileSearchHeight: "50%" });

    if (variables && minLengthMet && !selectedAddress) {
      const query = variables;
      query.address = value;
      this.getAddressesDebounced(query);
    }
    return null;
  }

  getAddressesDebounced = _.debounce(async (variables) => {
    const { useRecaptcha,  setVerificationToken, setVerificationAction } = this.props;
    const { skipGenerateNewToken } = this.state;
    if (useRecaptcha === 1) {
      await setCaptchaToken(setVerificationToken, setVerificationAction, captchaAction.addressSearching, skipGenerateNewToken);
    }
    this.getLocations(variables);
  }, 500);

  async getLocations(variables) {
    this.setState({ addressesLoading: true });
    const { setVerificationProvider } = this.props;

    try {
      const response = await client
        .query({
          query: LOCATIONS_VIA_ADDRESS_QUERY,
          fetchPolicy: "no-cache",
          variables
        });

        this.setState({
          showDefaultMap: false,
          addressesData: response.data,
          addressesLoading: false,
          locationLoading: false,
          showLocationSearchResults: false,
        });
        setVerificationProvider('');
    } catch (e) {
      this.locationErrorHandler(e.message)
    }
  }

  locationErrorHandler = (errorMsg) => {
    const hasUnauthorized = errorMsg.indexOf(httpStatusConstant.unauthorised) !== -1;
    if (hasUnauthorized) {
      this.setState({
        hasCaptchaError: hasUnauthorized,
        showCaptchaChallenge: hasUnauthorized,
      });
    } else {
      this.setState({
        showCaptchaChallenge: false,
        hasCaptchaError: false,
        skipGenerateNewToken: false,
        addressesData: {
          locationSearch: []
        },
      });
    }
    this.setState({ addressesLoading: false, locationSearchError: errorMsg });
  }

  setStoreLoading(isStoreLoading) {
    this.setState({
      storesLoading: isStoreLoading
    });
  }

  handleViewMenuClick = (store, e) => {
    this.setState({
      selectedStore: store,
      showModal: true,
    })
  };

  /**
   * Renders list search input UI
   */
  renderListSearch = () => {
    const {
      searchValue,
      selectedAddress,
      locationLoading,
      locationsList,
      myLocation,
      addressesData,
      addressesLoading,
      storesLoading,
      hasCaptchaError,
      locationSearchError,
      locationAccessDenied
    } = this.state;
    const { lat, lng } = myLocation || { lat: "", lng: "" };
    const { widgetValue, userOrderMethod } = this.props;
    const showDorms = userOrderMethod !== orderMethods.shipping ?? false;

    const addressQueryVars = {
      address: searchValue,
      fullyQualified: false,
      showDorms
    };

    if (lat && lng) {
      addressQueryVars.lat = lat;
      addressQueryVars.lng = lng;
    }

    const isBrandRefresh = isBrandRefreshEnabled();

    const hasSearchSuggestions =
      isBrandRefresh &&
      !addressesLoading &&
      searchValue.length > 0 &&
      !selectedAddress &&
      addressesData?.locationSearch?.length > 0;

    const searchInputContents = (
      <>
        <img
          alt=""
          src={isBrandRefresh ? searchIconBrandRefresh : searchIcon}
          data-part={isBrandRefresh ? 'search-input-icon' : undefined}
          className={isBrandRefresh ? LOCATIONS_SEARCH_ICON_BR : undefined}
        />
        <input
          type="text"
          id="search_location"
          ref={this.searchInput}
          value={widgetValue.length > 0 ? widgetValue : searchValue}
          className={getLocationsSearchInputClass(isBrandRefresh)}
          onChange={e =>
            this.handleLocationFilter(e.target.value, addressQueryVars)}
          placeholder="Search store, city, state, zip"
        />
        {(searchValue.length > 0 || widgetValue.length > 0) &&
        !addressesLoading ? (
          isBrandRefresh ? (
            <button
              onClick={this.clearSearch}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  this.clearSearch();
                }
              }}
              className={LOCATIONS_SEARCH_CLEAR_BTN_BR}
              type="button"
              aria-label="Clear search"
            >
              <img
                alt=""
                src={clearIconBrandRefresh}
                data-part="search-clear-icon"
                className={LOCATIONS_SEARCH_CLEAR_ICON_BR}
                aria-hidden="true"
              />
            </button>
          ) : (
            <>
              <button
                onClick={this.clearSearch}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.clearSearch();
                  }
                }}
                className={`${styles.clearIcon}  dark:hidden !bg-transparent w-4 h-4 items-center flex justify-center`}
                type="button"
                aria-label="Clear search"
              >
                <img
                  alt=""
                  src={clearIcon}
                  aria-hidden="true"
                />
              </button>
              <button
                onClick={this.clearSearch}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.clearSearch();
                  }
                }}
                className={`${styles.clearIcon} hidden dark:flex !bg-transparent w-4 h-4 items-center  justify-center`}
                type="button"
                aria-label="Clear search"
              >
                <img
                  alt=""
                  src={lightExitIcon}
                  aria-hidden="true"
                />
              </button>
            </>
          )
        ) : null}
      </>
    );

    return (
      <div style={{ height: !locationsList.length ? "100%" : "" }}>
        <div
          data-part={isBrandRefresh ? 'search-field-group' : undefined}
          data-has-suggestions={hasSearchSuggestions ? 'true' : undefined}
          className={
            isBrandRefresh
              ? LOCATIONS_SEARCH_FIELD_GROUP_BR
              : styles.locationsInputWrapper
          }
        >
          {isBrandRefresh ? (
            <div
              data-part="search-input-wrapper"
              className={getLocationsInputWrapperClass(styles, true)}
            >
              <div
                data-part="search-input-container"
                className={getLocationsSearchInputContainerClass(styles, true)}
              >
                {searchInputContents}
              </div>
              {!locationAccessDenied ? (
                <button
                  type="button"
                  data-part="search-location-btn"
                  className={LOCATIONS_SEARCH_LOCATION_BTN_BR}
                  aria-label="Use my location"
                  disabled={Boolean(locationLoading)}
                  onClick={this.handleMapGeolocate}
                >
                  <img
                    src={navigationArrowBrandRefresh}
                    alt=""
                    aria-hidden="true"
                    data-part="search-location-icon"
                  />
                </button>
              ) : null}
            </div>
          ) : (
            <div className={getLocationsSearchInputContainerClass(styles, false)}>
              {searchInputContents}
            </div>
          )}
          {!isBrandRefresh && (
            locationLoading ? (
              <span>
                {/* Loader removed - using global loader instead */}
              </span>
            ) : (
              myLocation && (
                <img
                  alt=""
                  onClick={() => {
                    this.setState({
                      searchLocation: myLocation
                    });
                    this.myLocationSearch();
                  }}
                  src={searchArrow}
                />
              )
            )
          )}
          {hasSearchSuggestions ? (
            <div data-part="location-search-suggestions">
              {addressesData.locationSearch.map(location => (
                <DeliveryLocationListItem
                  isBrandRefresh
                  onClick={() => {
                    const searchLocation = {
                      externalId: location.externalId,
                      lat: location.lat,
                      lng: location.lng
                    };
                    // Hide prior store list immediately; show cookie spinner until getStores finishes.
                    this.setState({
                      searchLocation,
                      searchValue: location.address1,
                      selectedAddress: location.address1,
                      showLocationSearchResults: false,
                      locationsList: [],
                    });

                    this.getStores(searchLocation);
                  }}
                  key={location.address1}
                  icon={locationPinBrandRefresh}
                  address1={location.address1}
                  addressDetails={location.addressDetails}
                />
              ))}
            </div>
          ) : null}
        </div>
        {hasCaptchaError ? this.renderCaptchaChallenge() : (locationSearchError) ? this.renderErrorUI() : null}
        {/* styling required here */}
        {!isBrandRefresh &&
          !addressesLoading &&
          searchValue.length > 0 &&
          !selectedAddress &&
          addressesData &&
          addressesData.locationSearch.length > 0 ? (
            <div className={styles.locationSearchAutoComplete}>
              {addressesData.locationSearch.map(location => (
                <DeliveryLocationListItem
                  customStyles={styles.customLocationItemStyles}
                  onClick={() => {
                  const searchLocation = {
                    externalId: location.externalId,
                    lat: location.lat,
                    lng: location.lng
                  };
                  this.setState({
                    searchLocation,
                    searchValue: location.address1,
                    selectedAddress: location.address1,
                    showLocationSearchResults: true,
                  });

                  this.getStores(searchLocation);
                }}
                  key={location.address1}
                  icon={locationIcon}
                  address1={location.address1}
                  addressDetails={location.addressDetails}
                />
            ))}
            </div>
        ) : null}
        {searchValue.length > 0 &&
        selectedAddress &&
        !storesLoading &&
        !locationsList.length ? (
          <div
            className={isBrandRefresh ? undefined : styles.locationSearchAutoComplete}
            data-part={isBrandRefresh ? 'no-stores-found' : undefined}
          >
            <div 
              className={isBrandRefresh ? undefined : styles.noStoresFound}
              role="status"
              aria-live="polite"
            >
              <h3 className={getLocationsNoStoresHeadingClass(isBrandRefresh)}>
                No stores found
              </h3>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  renderCaptchaChallenge = () => {
    const { showCaptchaChallenge } = this.state;
    const { useRecaptcha } = this.props;
    return (
      (showCaptchaChallenge && useRecaptcha) ? (
        <div className={styles.errorContainer}>
          <ReCAPTCHAForm
            ref={this.recaptchaComponentRef}
            setToken={this.onVerifyCaptcha}
          />
        </div>
      ) : null
    )
  };

  renderErrorUI = () => (
    <div className={styles.errorContainer}>
      <p>Oops, something went wrong</p>
      <p>There was a network error, try refreshing your browser.</p>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <span onClick={() => window.location.reload()}>Reload Page</span>
    </div>
  );

  onVerifyCaptcha = (token) => {
    if (token) {
      this.setState({
        showCaptchaChallenge: false,
        skipGenerateNewToken: true
      });

      const { setVerificationToken, setVerificationProvider, userOrderMethod } = this.props;
      const { searchValue } = this.state;
      setVerificationToken(token);
      setVerificationProvider(elementConstants.challengeRecaptcha);

      const showDorms = userOrderMethod !== orderMethods.shipping ?? false;

      const addressQueryVars = {
        address: searchValue,
        fullyQualified: false,
        showDorms
      };
      this.handleLocationFilter(searchValue, addressQueryVars);
    }
  }

  renderMobileViewToggle = () => {
    const { mobileViewMode } = this.state;
    const { selectedMapStore } = this.props;
    const isMapView = mobileViewMode === 'map';
    // Figma 5008:37380 — hide View List while the pin card is open (#18773)
    if (isMapView && selectedMapStore?.id) {
      return null;
    }
    const nextView = isMapView ? 'list' : 'map';
    const label = isMapView ? 'View List' : 'View Map';
    const icon = isMapView ? listBulletsBrandRefresh : mapTrifoldBrandRefresh;

    return (
      <button
        type="button"
        data-part="view-toggle"
        aria-label={label}
        onClick={() => this.setState({ mobileViewMode: nextView })}
      >
        <span data-part="view-toggle-content">
          <img
            alt=""
            src={icon}
            data-part="view-toggle-icon"
            aria-hidden="true"
          />
          <span data-part="view-toggle-label">{label}</span>
        </span>
      </button>
    );
  };

  locationsContainer = () => {
    const {
      showLocation,
      mobileSearchHeight,
      searchLocation,
      chosenLocationIndex,
      locationsList,
      showDefaultMap,
      selectedStoreIdFromTheSearchList,
      showModal,
      addressType,
      searchValue,
      selectedStore,
      showLocationSearchResults,
      mobileViewMode,
      myLocation,
      locationLoading,
      selectedAddress,
      storesLoading,
    } = this.state;

    const {
      userOrderMethod,
      history,
      addressComponents,
      userId,
      setUserCartId,
      setSelectedStore
    } = this.props;

    const updateOrderLocations = useMutation(UPDATE_ORDER_LOCATION, {
      onCompleted: async res => {
        const { storeId } = res.updateOrder;
        const state = reduxStore.store.getState();
        const { userCartId } = state.user;

        if (!userCartId) {
          const address = addressComponents
            ? {
                address1: addressComponents.address1,
                city: addressComponents.city,
                lat: addressComponents.lat,
                lng: addressComponents.lng,
                postcode: addressComponents.postcode,
                state: addressComponents.state,
                countryId: addressComponents.countryId
              }
            : null;

          const data = {
            storeId,
            orderTypeId: orderTypeIds.pickup,
            shippingMethod: shippingMethods.pickup,
            address,
            customerId: userId || 0
          };

          const response = await orderRepo.createCart(data);
          const { createCart } = response.data;

          setUserCartId(createCart.code);
        }
        history.push(routeCountryPath(endpoints.getMenuUrl(null)));
      }
    });

    const updateOrderLocation =
      updateOrderLocations.length > 0 ? updateOrderLocations[0] : null;

    const [ setAddresType] = useState();
    const [showDeliveryWidget, setShowDeliveryWidget] = useState(false);
    const isBrandRefresh = isBrandRefreshEnabled();
    const listTitleClassName = getLocationsListTitleClass(isBrandRefresh, showLocation);

    const pageShellClass = getLocationsPageShellClass(isBrandRefresh, showLocation);
    const usePageShell = Boolean(pageShellClass);

    // #18773 Carlos: while searching an address, hide map like list hides store results
    const isActivelySearchingAddress =
      isBrandRefresh
      && !showLocation
      && !selectedAddress
      && Boolean(searchValue && searchValue.length > 0);

    const pageContent = (
      <div
        data-region={isBrandRefresh && !showLocation ? 'find-a-bakery' : undefined}
        data-view={isBrandRefresh && !showLocation ? mobileViewMode : undefined}
        data-searching={
          isBrandRefresh && !showLocation && isActivelySearchingAddress
            ? 'true'
            : undefined
        }
        className={getLocationsPageWrapperClass(styles, isBrandRefresh, {
          showLocation,
        })}
      >
        <div id="deliveryPickUpWidget">
          {showModal ? (
            <DeliveryPickUpWidget
              inputValue={searchValue}
              showPickUpButton
              clickPickUpButton={(e) => this.storeSelect(e, updateOrderLocation)}
              onClose={(e) => this.onCloseWidget(setShowDeliveryWidget)}
              onAddressType={setAddresType}
              addressType={addressType}
              selectedPopupStore={selectedStore}
              analyticsPageSection="Category Images"
            />
          ) : null}
        </div>
        <div
          data-part={isBrandRefresh && !showLocation ? 'locations-panel' : undefined}
          className={`${styles.locationsContainer} md:flex flex-col gap-4`}
        >
          {showLocation ? renderExitIcon(this) : null}
          {/* MAIN HEADER */}
          {showLocation ? (
            <h1
              className="
               text-dark dark:text-white
              font-congenialBlack font-black text-4xl leading-9 tracking-tighter"
            >
              {locationsList[chosenLocationIndex].name}
            </h1>
          ) : (
            <h1
              data-part={isBrandRefresh ? 'page-title' : undefined}
              className={listTitleClassName}
            >
              {METADATA_INFO.HEADER_LINK.LOCATION}
            </h1>
          )}
          {/* SEARCH ELEMENT */}
          {!showLocation ? this.renderListSearch() : null}
          {/* STORE SEARCH RESULTS LIST — hide while typing / while stores reload */}
          {!showLocation
          && !storesLoading
          && locationsList
          && showLocationSearchResults
            ? renderListItems(
                this,
                locationsList,
                updateOrderLocation,
                this.handleViewMenuClick
              )
            : null}
          {/* CHOSEN LOCATION */}
          {showLocation && chosenLocationIndex !== undefined
            ? renderChosenLocation(
                this,
                locationsList[chosenLocationIndex],
                updateOrderLocation,
                userOrderMethod,
                this.handleViewMenuClick
              )
            : null}
        </div>
        <div
          data-part={isBrandRefresh ? 'map-container' : undefined}
          className={styles.mapContainer}
        >
          {isBrandRefresh && !showLocation ? (
            <div data-part="map-toggle-bar">
              {this.renderMobileViewToggle()}
            </div>
          ) : null}
          {!isBrandRefresh || showLocation ? (
            <img
              onClick={() => history.goBack()}
              alt=""
              src={mobileBackIcon}
            />
          ) : null}

          <div data-part={isBrandRefresh ? 'map-stage' : undefined}>
            <MapComponent
              showDefaultMap={showDefaultMap}
              mode="locations"
              stores={locationsList}
              isBrandRefresh={isBrandRefresh && !showLocation}
              hideGeolocateControl={isBrandRefresh && !showLocation}
              myLocation={myLocation}
              onBrandRefreshStoreDetailClick={
                isBrandRefresh && !showLocation
                  ? (store) => {
                      if (store?.slug) {
                        history.push(
                          routeCountryPath(`/store/${store.slug}`)
                        );
                      }
                    }
                  : undefined
              }
              searchLocation={
                searchLocation && searchLocation.lat && searchLocation.lng
                  ? searchLocation
                  : undefined
              }
              searchAddress={addressComponents}
              center={
                searchLocation.lat && searchLocation.lng
                  ? searchLocation
                  : undefined
              }
              selectedStoreId={selectedStoreIdFromTheSearchList}
            />
            {isBrandRefresh &&
            !showLocation &&
            searchValue.length > 0 &&
            selectedAddress &&
            !storesLoading &&
            !locationsList.length ? (
              <div
                data-part="map-no-stores"
                role="status"
                aria-live="polite"
              >
                <p>No stores found</p>
              </div>
            ) : null}
          </div>
          {/* MOBILE STYLES */}
          <div
            data-part={isBrandRefresh ? 'mobile-panel' : undefined}
            className={getLocationsMobilePanelClass(styles, isBrandRefresh && !showLocation)}
            style={
              isBrandRefresh && !showLocation
                ? undefined
                : { height: showLocation ? '75%' : mobileSearchHeight }
            }
          >
            {showLocation ? renderExitIcon(this) : null}
            {!showLocation && isBrandRefresh ? (
              <h1
                data-part="page-title"
                className={listTitleClassName}
              >
                {METADATA_INFO.HEADER_LINK.LOCATION}
              </h1>
            ) : null}
            {/* CHOSEN LOCATION */}
            {showLocation && chosenLocationIndex !== undefined
              ? renderChosenLocation(
                  this,
                  locationsList[chosenLocationIndex],
                  updateOrderLocation,
                  userOrderMethod,
                  this.handleViewMenuClick
                )
              : null}
            {/* SEARCH ELEMENT */}
            {!showLocation ? this.renderListSearch() : null}
            {/* SEARCH LIST — hide while typing / while stores reload */}
            {!showLocation
            && !storesLoading
            && locationsList
            && showLocationSearchResults
              ? renderListItems(this, locationsList, updateOrderLocation, this.handleViewMenuClick)
              : null}
          </div>
        </div>
        {/* full-viewport scrim + centered cookie spinner while stores load */}
        {isBrandRefresh && !showLocation && storesLoading ? (
          <div
            data-part="stores-loading"
            role="status"
            aria-live="polite"
            aria-label="Loading stores"
          >
            <Loader />
          </div>
        ) : null}
      </div>
    );

    if (usePageShell) {
      return (
        <div
          data-part="find-a-bakery-shell"
          data-view={!showLocation ? mobileViewMode : undefined}
          className={pageShellClass}
        >
          {pageContent}
        </div>
      );
    }

    return pageContent;
  };

  render() {
    return <this.locationsContainer />;
  }
}

const mapStateToProps = state => {
  const { addressComponents } = state.address;
  const { widgetOption, widgetValue, useRecaptcha } = state.elements;
  const {
    userCartId,
    selectedMapStore,
    userOrderMethod,
    selectedStore,
    userId
  } = state.user;
  const { phonePrefixes } = state.country;
  const {
    selectedCountry,
    allCountries,
    isCountrySelectActive
  } = state.country;
  const { redeemables } = state.loyalty;
  const orderProducts = state.order?.products || [];
  return {
    widgetOption,
    widgetValue,
    userCartId,
    addressComponents,
    orderProducts,
    selectedMapStore,
    userOrderMethod,
    phonePrefixes,
    selectedCountry,
    allCountries,
    isCountrySelectActive,
    selectedStore,
    redeemables,
    userId,
    useRecaptcha
  };
};

export const mapDispatchToProps = dispatch => ({
  setWidgetValue: value => dispatch(elementsActions.setWidgetValue(value)),
  setWidgetOption: value => dispatch(elementsActions.setWidgetOption(value)),
  setSelectedStore: value => dispatch(userActions.setSelectedStore(value)),
  setUserOrderMethod: value => dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: value => dispatch(userActions.setUserAddress(value)),
  setModalObject: value => dispatch(elementsActions.setModalObject(value)),
  addressUpdated: value => dispatch(addressActions.addressUpdated(value)),
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  setSelectedMapStore: value =>
    dispatch(userActions.setSelectedMapStore(value)),
  setAutocompleteSessionToken: value =>
    dispatch(elementsActions.setAutocompleteSessionToken(value)),
  setSelectedCountry: value =>
    dispatch(countryActions.setSelectedCountry(value)),
  setRedeemableItem: value => dispatch(loyaltyAction.setRedeemableItem(value)),
  setVerificationToken: value =>
    dispatch(elementsActions.setVerificationToken(value)),
  setVerificationAction: value =>
    dispatch(elementsActions.setVerificationAction(value)),
  setVerificationProvider: value =>
    dispatch(elementsActions.setVerificationProvider(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Locations);
